// Auto-generated per-query builders for Project
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { ProjectReadAPI, ProjectWriteAPI, ProjectReadAPISchema, ProjectWriteAPISchema } from '../types/project';
import { ModelRegistry } from '../../registries/model-registry';
import { AnalysisRecordOfProject, AtScope, ChangeImpactOfProject, ContainsPhysicalPart, ContainsSoftwarePart, CurrentTaskAttachedTo, GroupAt, HasAttribute, HasAttributeValue, HasDerivedValue, HasRFLPProject, IslandHoldsPin, Mentions, ParentScope, ProjectHasRootPart, ProposalBatchOfProject } from '../../relationships/relationship';

import { ChangeImpact } from './changeimpact';
import { ProposalBatch } from './proposalbatch';
import { LogicalPart } from './logicalpart';
import { PhysicalPart } from './physicalpart';
import { SoftwarePart } from './softwarepart';
import { SecurityScope } from '../../shared/api/securityscope';
import { Attribute } from './attribute';
import { AttributeValue } from './attributevalue';
import { DerivedValue } from './derivedvalue';
import { Expression } from './expression';
import { AnalysisRecord } from './analysisrecord';
import { Workspace } from '../../base/api/workspace';
import { Group } from '../../base/api/group';
import { IslandPin } from './islandpin';
import { Task } from '../../tasks/api/task';





// Builder chain for query: rflp-project-by-id

export interface RflpProjectByIdBuilder_0 {
  get(id: string): RflpProjectByIdBuilder_1;
  filter(conditions: { id: string }): RflpProjectByIdBuilder_1;
}

export interface RflpProjectByIdBuilder_1 {
  all(): Promise<Project[]>;
  first(): Promise<Project | null>;
  get(): Promise<Project[]>;
  execute(): Promise<Project[]>;
}

// Builder chain for query: rflp-project-change-impacts

export interface RflpProjectChangeImpactsBuilder_0 {
  get(id: string): RflpProjectChangeImpactsBuilder_1;
  filter(conditions: { id: string }): RflpProjectChangeImpactsBuilder_1;
}

export interface RflpProjectChangeImpactsBuilder_1 {
  change_impacts: RflpProjectChangeImpactsBuilder_2;
}

export interface RflpProjectChangeImpactsBuilder_2 {
  all(): Promise<ChangeImpact[]>;
  first(): Promise<ChangeImpact | null>;
  get(): Promise<ChangeImpact[]>;
  execute(): Promise<ChangeImpact[]>;
}


// Union of all query entry points
export type ProjectQueryBuilder = RflpProjectByIdBuilder_0 | RflpProjectChangeImpactsBuilder_0;

// Available query names for .setQuery()
export type ProjectQueryNames = "rflp-project-by-id" | "rflp-project-change-impacts";

// Type narrowing for .setQuery()
export type ProjectBuilderForQuery<Q extends ProjectQueryNames> =
  Q extends "rflp-project-by-id" ? RflpProjectByIdBuilder_0
  : Q extends "rflp-project-change-impacts" ? RflpProjectChangeImpactsBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type ProjectInstanceQueryResult<Q extends ProjectQueryNames> =
  Q extends "rflp-project-by-id" ? RflpProjectByIdBuilder_1
  : Q extends "rflp-project-change-impacts" ? RflpProjectChangeImpactsBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  '': 'rflp-project-by-id',
  'change_impacts': 'rflp-project-change-impacts',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends ProjectQueryNames>(queryName: Q): ProjectBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}

Object.defineProperty(QueryBuilderImpl.prototype, 'change_impacts', {
  get() {
    return new QueryBuilderImpl('ChangeImpact', [...this.path, 'change_impacts'], this.params, this.fetchFn, this.queryName, this.scopedParams);
  },
  enumerable: true,
  configurable: true
});

export interface Project extends Partial<ProjectReadAPI> {}
export class Project extends NeoNodeBase<ProjectReadAPI, ProjectWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "Project";
  static readonly readSchema = ProjectReadAPISchema;
  static readonly writeSchema = ProjectWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    attributes: { target: "Attribute", cardinality: "many", isParent: false, relClass: "HasAttribute", direction: "out" },
    attribute_values: { target: "AttributeValue", cardinality: "many", isParent: false, relClass: "HasAttributeValue", direction: "out" },
    derived_values: { target: "DerivedValue", cardinality: "many", isParent: false, relClass: "HasDerivedValue", direction: "out" },
    mentioned_in_expressions: { target: "Expression", cardinality: "many", isParent: false, relClass: "Mentions", direction: "in" },
    analysis_records: { target: "AnalysisRecord", cardinality: "many", isParent: false, relClass: "AnalysisRecordOfProject", direction: "in" },
    change_impacts: { target: "ChangeImpact", cardinality: "many", isParent: false, relClass: "ChangeImpactOfProject", direction: "in" },
    proposal_batches: { target: "ProposalBatch", cardinality: "many", isParent: false, relClass: "ProposalBatchOfProject", direction: "in" },
    workspace: { target: "Workspace", cardinality: "one", isParent: false, relClass: "HasRFLPProject", direction: "in" },
    parent_scope: { target: "SecurityScope", cardinality: "one", isParent: false, relClass: "ParentScope", direction: "out" },
    child_scopes: { target: "SecurityScope", cardinality: "many", isParent: false, relClass: "ParentScope", direction: "in" },
    groups: { target: "Group", cardinality: "many", isParent: false, relClass: "GroupAt", direction: "in" },
    root_part: { target: "LogicalPart", cardinality: "one", isParent: false, relClass: "ProjectHasRootPart", direction: "out" },
    physical_parts: { target: "PhysicalPart", cardinality: "many", isParent: false, relClass: "ContainsPhysicalPart", direction: "out" },
    software_parts: { target: "SoftwarePart", cardinality: "many", isParent: false, relClass: "ContainsSoftwarePart", direction: "out" },
    island_pins: { target: "IslandPin", cardinality: "many", isParent: false, relClass: "IslandHoldsPin", direction: "out" },
    current_tasks: { target: "Task", cardinality: "many", isParent: false, relClass: "CurrentTaskAttachedTo", direction: "in" },
  };

  protected get modelName(): string {
    return 'Project';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return Project.label;
  }


  constructor(data: Partial<ProjectWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: ProjectReadAPI, loadContext?: Record<string, any>): Project {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { groups, root_part, physical_parts, software_parts, security_scope, attributes, attribute_values, derived_values, mentioned_in_expressions, analysis_records, change_impacts, proposal_batches, workspace, parent_scope, child_scopes, island_pins, current_tasks, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = ProjectReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, groups: groups, root_part: root_part, physical_parts: physical_parts, software_parts: software_parts, security_scope: security_scope, attributes: attributes, attribute_values: attribute_values, derived_values: derived_values, mentioned_in_expressions: mentioned_in_expressions, analysis_records: analysis_records, change_impacts: change_impacts, proposal_batches: proposal_batches, workspace: workspace, parent_scope: parent_scope, child_scopes: child_scopes, island_pins: island_pins, current_tasks: current_tasks };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return Project.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'groups', 'Group', ModelRegistry);
    loadOneRelationship(processed, 'root_part', 'LogicalPart', ModelRegistry);
    loadManyRelationship(processed, 'physical_parts', 'PhysicalPart', ModelRegistry);
    loadManyRelationship(processed, 'software_parts', 'SoftwarePart', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadManyRelationship(processed, 'attributes', 'Attribute', ModelRegistry);
    loadManyRelationship(processed, 'attribute_values', 'AttributeValue', ModelRegistry);
    loadManyRelationship(processed, 'derived_values', 'DerivedValue', ModelRegistry);
    loadManyRelationship(processed, 'mentioned_in_expressions', 'Expression', ModelRegistry);
    loadManyRelationship(processed, 'analysis_records', 'AnalysisRecord', ModelRegistry);
    loadManyRelationship(processed, 'change_impacts', 'ChangeImpact', ModelRegistry);
    loadManyRelationship(processed, 'proposal_batches', 'ProposalBatch', ModelRegistry);
    loadOneRelationship(processed, 'workspace', 'Workspace', ModelRegistry);
    loadOneRelationship(processed, 'parent_scope', 'SecurityScope', ModelRegistry);
    loadManyRelationship(processed, 'child_scopes', 'SecurityScope', ModelRegistry);
    loadManyRelationship(processed, 'island_pins', 'IslandPin', ModelRegistry);
    loadManyRelationship(processed, 'current_tasks', 'Task', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new Project(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): ProjectQueryBuilder {
    return new QueryBuilderImpl('Project').filter(conditions) as any;
  }

  static all(): ProjectQueryBuilder {
    return new QueryBuilderImpl('Project') as any;
  }

  static async first(): Promise<Project | null> {
    const results = await new QueryBuilderImpl('Project').execute();
    return results[0] || null;
  }


  static setQuery<Q extends ProjectQueryNames>(queryName: Q): ProjectBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('Project');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends ProjectQueryNames>(queryName: Q): ProjectInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = Project.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  /**
   * Delete this instance from the server.
   *
   * @param options - Delete options
   * @param options.cascade - Whether to cascade delete related nodes (default: true for most models)
   * @param options.dryRun - If true, return what would be deleted without actually deleting
   * @returns DeleteResult with deleted IDs and count
   *
   * @example
   * ```typescript
   * const project = await Project.get(id).first();
   * await project.delete();  // Delete with default cascade
   *
   * // Or with options
   * const result = await project.delete({ cascade: false, dryRun: true });
   * console.log('Would delete:', result.deletedIds);
   * ```
   */
  async delete(options: {
    cascade?: boolean;
    dryRun?: boolean;
  } = {}): Promise<{ deletedIds: string[]; count: number }> {
    return this._deleteInstance(options);
  }

  // Relationship manager for 'proposal_batches' - Python ORM style (cached)
  get proposal_batches(): RelationshipManager<this, ProposalBatch> {
    return this.getOrCreateRelationshipManager('proposal_batches', () => {
      return new RelationshipManager(this, 'proposal_batches', 'many', ProposalBatchOfProject as typeof Relationship);
    });
  }

  // Relationship manager for 'root_part' - Python ORM style (cached)
  get root_part(): RelationshipManager<this, LogicalPart> {
    return this.getOrCreateRelationshipManager('root_part', () => {
      return new RelationshipManager(this, 'root_part', 'one', ProjectHasRootPart as typeof Relationship);
    });
  }

  // Relationship manager for 'physical_parts' - Python ORM style (cached)
  get physical_parts(): RelationshipManager<this, PhysicalPart> {
    return this.getOrCreateRelationshipManager('physical_parts', () => {
      return new RelationshipManager(this, 'physical_parts', 'many', ContainsPhysicalPart as typeof Relationship);
    });
  }

  // Relationship manager for 'children' - Python ORM style (cached)
  get children(): RelationshipManager<this, PhysicalPart> {
    return this.getOrCreateRelationshipManager('children', () => {
      return new RelationshipManager(this, 'children', 'many', ContainsPhysicalPart as typeof Relationship);
    });
  }

  // Relationship manager for 'software_parts' - Python ORM style (cached)
  get software_parts(): RelationshipManager<this, SoftwarePart> {
    return this.getOrCreateRelationshipManager('software_parts', () => {
      return new RelationshipManager(this, 'software_parts', 'many', ContainsSoftwarePart as typeof Relationship);
    });
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'attributes' - Python ORM style (cached)
  get attributes(): RelationshipManager<this, Attribute> {
    return this.getOrCreateRelationshipManager('attributes', () => {
      return new RelationshipManager(this, 'attributes', 'many', HasAttribute as typeof Relationship);
    });
  }

  // Relationship manager for 'attribute_values' - Python ORM style (cached)
  get attribute_values(): RelationshipManager<this, AttributeValue> {
    return this.getOrCreateRelationshipManager('attribute_values', () => {
      return new RelationshipManager(this, 'attribute_values', 'many', HasAttributeValue as typeof Relationship);
    });
  }

  // Relationship manager for 'derived_values' - Python ORM style (cached)
  get derived_values(): RelationshipManager<this, DerivedValue> {
    return this.getOrCreateRelationshipManager('derived_values', () => {
      return new RelationshipManager(this, 'derived_values', 'many', HasDerivedValue as typeof Relationship);
    });
  }

  // Relationship manager for 'mentioned_in_expressions' - Python ORM style (cached)
  get mentioned_in_expressions(): RelationshipManager<this, Expression> {
    return this.getOrCreateRelationshipManager('mentioned_in_expressions', () => {
      return new RelationshipManager(this, 'mentioned_in_expressions', 'many', Mentions as typeof Relationship);
    });
  }

  // Relationship manager for 'analysis_records' - Python ORM style (cached)
  get analysis_records(): RelationshipManager<this, AnalysisRecord> {
    return this.getOrCreateRelationshipManager('analysis_records', () => {
      return new RelationshipManager(this, 'analysis_records', 'many', AnalysisRecordOfProject as typeof Relationship);
    });
  }

  // Relationship manager for 'change_impacts' - Python ORM style (cached)
  get change_impacts(): RelationshipManager<this, ChangeImpact> {
    return this.getOrCreateRelationshipManager('change_impacts', () => {
      return new RelationshipManager(this, 'change_impacts', 'many', ChangeImpactOfProject as typeof Relationship);
    });
  }

  // Relationship manager for 'workspace' - Python ORM style (cached)
  get workspace(): RelationshipManager<this, Workspace> {
    return this.getOrCreateRelationshipManager('workspace', () => {
      return new RelationshipManager(this, 'workspace', 'one', HasRFLPProject as typeof Relationship);
    });
  }

  // Relationship manager for 'parent_scope' - Python ORM style (cached)
  get parent_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('parent_scope', () => {
      return new RelationshipManager(this, 'parent_scope', 'one', ParentScope as typeof Relationship);
    });
  }

  // Relationship manager for 'child_scopes' - Python ORM style (cached)
  get child_scopes(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('child_scopes', () => {
      return new RelationshipManager(this, 'child_scopes', 'many', ParentScope as typeof Relationship);
    });
  }

  // Relationship manager for 'groups' - Python ORM style (cached)
  get groups(): RelationshipManager<this, Group> {
    return this.getOrCreateRelationshipManager('groups', () => {
      return new RelationshipManager(this, 'groups', 'many', GroupAt as typeof Relationship);
    });
  }

  // Relationship manager for 'island_pins' - Python ORM style (cached)
  get island_pins(): RelationshipManager<this, IslandPin> {
    return this.getOrCreateRelationshipManager('island_pins', () => {
      return new RelationshipManager(this, 'island_pins', 'many', IslandHoldsPin as typeof Relationship);
    });
  }

  // Relationship manager for 'current_tasks' - Python ORM style (cached)
  get current_tasks(): RelationshipManager<this, Task> {
    return this.getOrCreateRelationshipManager('current_tasks', () => {
      return new RelationshipManager(this, 'current_tasks', 'many', CurrentTaskAttachedTo as typeof Relationship);
    });
  }

}
